module.exports = __webpack_public_path__ + "talent-network.eeaea08cd92b82f46fda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/talent-network.png
// module id = 432
// module chunks = 1